// PrintSafetyRecord.jsx
import React, { useEffect, useState } from 'react';
import './PrintSafetyRecordHui.less'; // 单独的打印样式
import * as CONF from "../../common/config";
import * as REQUEST from "../../common/request";
import moment from 'moment';
const PrintSafetyRecord = () => {
    const [recordData, setRecordData] = useState(null);

    const getList = async (id) => {
        console.log('id===', id);
        // data.page = data.page || 0;
        const result = await REQUEST.get({
            url: '/check/get',
            data: { id: id },
        });
        if (!result) return;
        setRecordData(result && result.data);
    };


    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const dataStr = query.get('data');
        const data = JSON.parse(decodeURIComponent(dataStr));
        getList(data);
    }, []);

    const getLastHuiTime = (checklist = []) => {
        const list = checklist.filter(item => item.resulthuiTime);
        if (list.length === 0) return '';
        return list[list.length - 1].resulthuiTime;
    };

    return (
        <div className="a4-page">
            <h1 className="title">朱家角镇人民政府</h1>
            <h2 className="sub-title">
                回头看记录 {recordData && recordData.code} 号
            </h2>

            <div className="row">
                单位名称：<span className="line long">{recordData && recordData.companyInfo.companyName}</span>
            </div>

            <div className="row">
                地址：<span className="line long">{recordData && recordData.companyInfo.address}</span>
            </div>

            <div className="row">
                法定代表人（负责人）：
                <span className="line small">{recordData && recordData.companyInfo.safetyName}</span>
                职务：
                <span className="line small">安全负责人</span>
                联系电话：
                <span className="line small">{recordData && recordData.companyInfo.safetyTel}</span>
            </div>

            <div className="row">
                场所：<span className="line long">{recordData && recordData.checklist[0].place}</span>
            </div>

            <div className="row">
                时间：
                <span className="line long">{recordData && recordData.checklist[0].updatedAt}</span>
            </div>
            <div> 情况描述： </div>
            {
                recordData && recordData.checklist.map((item, index) => {
                    return <div key={index}>
                        <div>{index + 1}、{item.resulthui}</div>
                        {/* <div>
                            {item.resulthuiImages && item?.resulthuiImages.split(',').map((imgUrl, imgIndex) => {
                                return <img className="content-img" src={CONF.imgPrefix + imgUrl} key={imgIndex}></img>
                            })
                            }
                        </div> */}
                        {/* <div>{item.resulthui}</div> */}
                        <div>
                            {item.resulthuiImages && item?.resulthuiImages.split(',').map((imgUrl, imgIndex) => {
                                return <img className="content-img" src={CONF.imgPrefix + imgUrl} key={imgIndex}></img>
                            })
                            }
                        </div>
                    </div>
                })
            }

            <div className="row" style={{marginTop:20}}>
                建议被指导单位根据相关法律法规，加强安全生产管理和工作措施，防范事故发生。
            </div>
            <div className="row">
                工作人员（签名）：<span className="line long"> {recordData && recordData.checklist.length > 0 && <div><img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].jc_signature}></img> 、 <img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].jz_signature}></img></div>}</span>
            </div>
            <div className="row">
                单位现场负责人（签名）：<span className="line long"> {recordData && recordData.checklist.length > 0 && <img className="qmimg" src={CONF.imgPrefix + recordData.checklist[0].compamy_sign}></img>}</span>
            </div>
            <div className="date-right">
                {
                    recordData &&
                    getLastHuiTime(recordData.checklist) &&
                    moment(getLastHuiTime(recordData.checklist)).format('YYYY年MM月DD日')
                }
            </div>
        </div>
    );
};

export default PrintSafetyRecord;